export function createHighlights(hit, fieldName, tokensFieldName) {
  var tokensHighlights = hit.getIn(['_highlightResult', tokensFieldName]);
  return tokensHighlights ? tokensHighlights.filter(function (h) {
    return h.get('matchLevel') !== 'none';
  }).map(function (h) {
    return h.get('value');
  }).push(hit.getIn(['_highlightResult', fieldName, 'value'])).join(' ') : hit.getIn(['_highlightResult', fieldName, 'value']);
}